define.alias("shared/components/shared/schedule-navbar", "calendar/components/shared/schedule-navbar");